import(/* webpackMode: "eager" */ "/home/runner/work/Invoice/Invoice/src/app/invoice/projects/page.js");
